// extracted by mini-css-extract-plugin
export default {"nav":"BottomNav_nav__754Cy","icon":"BottomNav_icon__nr0WO","label":"BottomNav_label__2wik9","tab":"BottomNav_tab__5cD4X","active":"BottomNav_active__dCtrl"};